export default {"src":"/_next/static/media/ribbon.b682723c.svg","height":111,"width":111,"blurWidth":0,"blurHeight":0};